import React from "react";

import PrivateRoute from "./private";

import Dashboard from "../pages/dashboard";
import CategoriaListar from "../pages/categoria/listar";
import CategoriaCadastrar from "../pages/categoria/cadastrar";

import CalculoGeradoListar from "../pages/calculo-gerado/listar";

import ProdutoListar from "../pages/produto/listar";
import ProdutoCadastrar from "../pages/produto/cadastrar";

import NovidadeListar from "../pages/novidade/listar";
import NovidadeCadastrar from "../pages/novidade/cadastrar";

import CatalogoListar from "../pages/catalogo/listar";
import CatalogoCadastrar from "../pages/catalogo/cadastrar";

import SetorListar from "../pages/setor/listar";
import SetorCadastrar from "../pages/setor/cadastrar";

import ContatoListar from "../pages/contato/listar";
import ContatoCadastrar from "../pages/contato/cadastrar";

import RedeSocialListar from "../pages/rede-social/listar";
import RedeSocialCadastrar from "../pages/rede-social/cadastrar";

import VendedorListar from "../pages/vendedor/listar";
import VendedorCadastrar from "../pages/vendedor/cadastrar";

import RegiaoListar from "../pages/regiao/listar";
import RegiaoCadastrar from "../pages/regiao/cadastrar";

import UsuarioListar from "../pages/usuario/listar";
import UsuarioCadastrar from "../pages/usuario/cadastrar";

import EmpresaCadastrar from "../pages/empresa/cadastrar";

import ProjetoListar from "../pages/projeto/listar";
import ProjetoCadastrar from "../pages/projeto/cadastrar";

import FilialListar from "../pages/filial/listar";
import FilialCadastrar from "../pages/filial/cadastrar";

import LinkListar from "../pages/link/listar";
import LinkCadastrar from "../pages/link/cadastrar";

import RegiaoVendedorListar from "../pages/regiao-vendedor/listar";
import RegiaoVendedorCadastrar from "../pages/regiao-vendedor/cadastrar";

import MarcoHistoricoListar from "../pages/marco-historico/listar";
import MarcoHistoricoCadastrar from "../pages/marco-historico/cadastrar";

import TipoProjetoListar from "../pages/tipo-projeto/listar";
import TipoProjetoCadastrar from "../pages/tipo-projeto/cadastrar";

import CaracteristicaListar from "../pages/caracteristica/listar";
import CaracteristicaCadastrar from "../pages/caracteristica/cadastrar";

const Rotas = () => [
  <PrivateRoute key={Math.random()} path="/" exact component={Dashboard} />,
  
  <PrivateRoute
    key={Math.random()}
    path="/calculosGerados"
    exact
    component={CalculoGeradoListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/empresa"
    exact
    component={EmpresaCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/categoria"
    exact
    component={CategoriaListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/categoria/cadastrar"
    exact
    component={CategoriaCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/categoria/editar"
    exact
    component={CategoriaCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/produto"
    exact
    component={ProdutoListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/produto/cadastrar"
    exact
    component={ProdutoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/produto/editar"
    exact
    component={ProdutoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/novidade"
    exact
    component={NovidadeListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/novidade/cadastrar"
    exact
    component={NovidadeCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/novidade/editar"
    exact
    component={NovidadeCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/manuais"
    exact
    component={CatalogoListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/manuais/cadastrar"
    exact
    component={CatalogoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/manuais/editar"
    exact
    component={CatalogoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/setor"
    exact
    component={SetorListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/setor/cadastrar"
    exact
    component={SetorCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/setor/editar"
    exact
    component={SetorCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/contato"
    exact
    component={ContatoListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/contato/cadastrar"
    exact
    component={ContatoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/contato/editar"
    exact
    component={ContatoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/rede-social"
    exact
    component={RedeSocialListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/rede-social/cadastrar"
    exact
    component={RedeSocialCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/rede-social/editar"
    exact
    component={RedeSocialCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/vendedor"
    exact
    component={VendedorListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/vendedor/cadastrar"
    exact
    component={VendedorCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/vendedor/editar"
    exact
    component={VendedorCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/regiao"
    exact
    component={RegiaoListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/regiao/cadastrar"
    exact
    component={RegiaoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/regiao/editar"
    exact
    component={RegiaoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/regiao-vendedor"
    exact
    component={RegiaoVendedorListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/regiao-vendedor/cadastrar"
    exact
    component={RegiaoVendedorCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/regiao-vendedor/editar"
    exact
    component={RegiaoVendedorCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/usuario"
    exact
    component={UsuarioListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/usuario/cadastrar"
    exact
    component={UsuarioCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/usuario/editar"
    exact
    component={UsuarioCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/projeto"
    exact
    component={ProjetoListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/projeto/cadastrar"
    exact
    component={ProjetoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/projeto/editar"
    exact
    component={ProjetoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/filial"
    exact
    component={FilialListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/filial/cadastrar"
    exact
    component={FilialCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/filial/editar"
    exact
    component={FilialCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/link"
    exact
    component={LinkListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/link/cadastrar"
    exact
    component={LinkCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/link/editar"
    exact
    component={LinkCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/marco-historico"
    exact
    component={MarcoHistoricoListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/marco-historico/cadastrar"
    exact
    component={MarcoHistoricoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/marco-historico/editar"
    exact
    component={MarcoHistoricoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/tipo-projeto"
    exact
    component={TipoProjetoListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/tipo-projeto/cadastrar"
    exact
    component={TipoProjetoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/tipo-projeto/editar"
    exact
    component={TipoProjetoCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/caracteristica"
    exact
    component={CaracteristicaListar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/caracteristica/cadastrar"
    exact
    component={CaracteristicaCadastrar}
  />,

  <PrivateRoute
    key={Math.random()}
    path="/caracteristica/editar"
    exact
    component={CaracteristicaCadastrar}
  />,
];

export default Rotas;
